export default "__VITE_ASSET__6mMSa23$__"